import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container document-view" }
const _hoisted_2 = { class: "breadcrumb-voucher py-3" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = { class: "breadcrumb-item active" }
const _hoisted_8 = {
  class: "main gap-4",
  role: "main"
}
const _hoisted_9 = { class: "d-flex flex-column col-md-12 col-lg-6" }
const _hoisted_10 = { class: "h-x-small ps-0" }
const _hoisted_11 = { class: "ps-1" }
const _hoisted_12 = {
  key: 0,
  class: "notes-list p-0"
}
const _hoisted_13 = { class: "uploads w-100" }
const _hoisted_14 = { class: "d-flex justify-content-end action-section flex-row" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Wizzard = _resolveComponent("Wizzard")!
  const _component_Selectable = _resolveComponent("Selectable")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_FilesLoader = _resolveComponent("FilesLoader")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createElementVNode("ol", _hoisted_4, [
          _createElementVNode("li", _hoisted_5, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  class: "color--info",
                  name: "house"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "color--info",
              to: `/`
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", null, "Emissão de certificado", -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              class: "color--primary disabled fw-600",
              to: "/"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Envio de arquivos")
              ])),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_Wizzard, {
      "current-page": "alldone",
      role: "nav"
    }),
    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "fw-600" }, "Agora vamos precisar de alguns documentos", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _cache[7] || (_cache[7] = _createElementVNode("p", null, "Selecione o tipo de empresa para ver a lista de documentos.", -1)),
        _createVNode(_component_Selectable, {
          name: "companySegment",
          icon: "building",
          options: _ctx.form.types,
          modelValue: _ctx.companySegmentSeleted,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companySegmentSeleted) = $event)),
          labelSelectable: "nome",
          placeholder: "Selecione"
        }, null, 8, ["options", "modelValue"]),
        _withDirectives(_createVNode(_component_Selectable, {
          class: "mt-4",
          name: "companySegment",
          icon: "building",
          options: _ctx.form.documents,
          modelValue: _ctx.companyTypeSelected,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyTypeSelected) = $event)),
          labelSelectable: "nome",
          placeholder: "Selecione um tipo de unidade"
        }, null, 8, ["options", "modelValue"]), [
          [_vShow, !!_ctx.companySegmentSeleted]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["text-documents-required", [_ctx.companyTypeSelected !== "" ? "d-flex" : "d-none"]])
        }, [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.companyType.nome), 1),
          _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyType.list, (doc) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(doc), 1)
              ]))
            }), 256))
          ]),
          (_ctx.hasNotes)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyType.notas, (nota) => {
                  return (_openBlock(), _createElementBlock("li", null, [
                    _createElementVNode("span", null, [
                      _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Nota:", -1)),
                      _createTextVNode(" " + _toDisplayString(nota), 1)
                    ])
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Upload, {
          class: "element-sticky flex-grow-1",
          "is-mobile": _ctx.isMobile,
          "files-loaded": _ctx.filesLoaded,
          "extension-types": _ctx.extentionsAllows,
          onAddFile: _ctx.handleAddFile
        }, null, 8, ["is-mobile", "files-loaded", "extension-types", "onAddFile"]),
        _createVNode(_component_FilesLoader, {
          "files-loaded": _ctx.filesLoaded,
          "extension-types": _ctx.extentionsAllows,
          onHandleDeleteFile: _ctx.handleDeleteFile
        }, null, 8, ["files-loaded", "extension-types", "onHandleDeleteFile"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn", _ctx.isInvalid ? "btn-secondary disabled" : "btn-primary"]),
        type: "button",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendFiles && _ctx.sendFiles(...args))),
        disabled: _ctx.isInvalid
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
        _createVNode(_component_Icon, { name: "arrow-right" })
      ], 10, _hoisted_15)
    ]),
    _createVNode(_component_Contact, { style: {"margin-bottom":"6rem"} })
  ]))
}